import React, { Fragment } from 'react';
import lodash from 'lodash';
import moment from 'moment';
import InputField from 'components/common/Study/InputField';
import Input from 'components/common/Input/FormInput';
import styles from './StudyUsersAddMonitorForm.scss';

export const StudyUsersAddMonitorForm = (props) => {
    const {
        externalUser: {
            firstName,
            lastName,
            //emailAddress,
            startDate,
            startTime,
            endDate,
            endTime,
            notify,
        } = {},
        externalUser,
        endDateIsValid,
        endTimeIsValid,
        //isExistingExternalUser,
        existingUser,
        editMode,
        submitBtnClicked,
        setSubmitBtnClicked,
        updateExternalUserInputs,
        complion4FlagEnabled,
    } = props;

    const updateFieldValue = (nameOrEvent, value) => {
        let name, val;
        if (typeof nameOrEvent === 'string') {
            name = nameOrEvent;
            val = value && moment(value).format('YYYY-MM-DD');
        } else {
            const { target: { name: targetName, value: targetValue } = {} } = nameOrEvent || {};
            name = targetName;
            val = targetValue;
        }
        updateExternalUserInputs(name, val);
        setSubmitBtnClicked(false);
    };

    const isValid = (name) => {
        return !submitBtnClicked || !lodash.isEmpty(externalUser[name]);
    };

    const toggle = () => {
        updateFieldValue({ target: { name: 'notify', value: !notify } });
    };

    return (
        <Fragment>
            <div className={styles.flexContainer}>
                <div className={styles.flexItem}>
                    <InputField required={false}>
                        <Input
                            title='First Name'
                            value={firstName}
                            disabled={(existingUser.sub !== undefined && existingUser.sub !== null) && !editMode}
                            name='firstName'
                            placeholder='Enter First Name'
                            required
                            errorOnSubmit={true}
                            isValid={isValid.bind(null, 'firstName')}
                            errorText='First Name is required'
                            onBlur={updateFieldValue}
                            onChange={updateFieldValue}
                            className='weighted'
                            withBorder={true}
                            submitClicked={submitBtnClicked}
                            data-cy='StudyUsersAddMonitorForm-FirstName'
                        />
                    </InputField>
                </div>
                <div className={styles.flexItem}>
                    <InputField required={false}>
                        <Input
                            title='Last Name'
                            value={lastName}
                            disabled={(existingUser.sub !== undefined && existingUser.sub !== null) && !editMode}
                            name='lastName'
                            placeholder='Enter Last Name'
                            required
                            isValid={isValid.bind(null, 'lastName')}
                            errorText='Last Name is required'
                            onBlur={updateFieldValue}
                            onChange={updateFieldValue}
                            className='weighted'
                            withBorder={true}
                            submitClicked={submitBtnClicked}
                            data-cy='StudyUsersAddMonitorForm-LastName'
                        />
                    </InputField>
                </div>
            </div>
            <div className={styles.flexContainer}>
                <div className={styles.flexItem}>
                    <InputField required={false}>
                        <Input
                            title='Start Date'
                            value={startDate}
                            name='startDate'
                            placeholder='DD MMM YYYY'
                            type='dateV4'
                            max={endDate ? moment(endDate) : (new Date(2099, 11, 31))}
                            required
                            isValid={isValid.bind(null, 'startDate')}
                            errorText='A valid Start Date is required'
                            onBlur={(e) => updateFieldValue('startDate', e)}
                            onChange={(e) => updateFieldValue('startDate', e)}
                            withBorder={true}
                            submitClicked={submitBtnClicked}
                            data-cy='StudyUsersAddMonitorForm-StartDate'
                        />
                    </InputField>
                </div>
                <div className={styles.flexItem}>
                    <InputField required={false}>
                        <Input
                            title='Start Time'
                            value={startTime}
                            name='startTime'
                            placeholder='hh:mm'
                            type='time'
                            required
                            isValid={isValid.bind(null, 'startTime')}
                            errorText='A valid Start Time is required'
                            onBlur={updateFieldValue}
                            onChange={updateFieldValue}
                            withBorder={true}
                            submitClicked={submitBtnClicked}
                            data-cy='StudyUsersAddMonitorForm-StartTime'
                        />
                    </InputField>
                </div>
            </div>
            <div className={styles.flexContainer}>
                <div className={styles.flexItem}>
                    <InputField required={false}>
                        <Input
                            title='End Date'
                            value={endDate}
                            name='endDate'
                            placeholder='DD MMM YYYY'
                            type='dateV4'
                            min={moment(startDate)}
                            isValid={endDateIsValid}
                            errorText='End Date cannot be earlier than Start Date'
                            onBlur={(e) => updateFieldValue('endDate', e)}
                            onChange={(e) => updateFieldValue('endDate', e)}
                            withBorder={true}
                            data-cy='StudyUsersAddMonitorForm-EndDate'
                        />
                    </InputField>
                </div>
                <div className={styles.flexItem}>
                    <InputField required={false}>
                        <Input
                            title='End Time'
                            value={endTime}
                            name='endTime'
                            placeholder='hh:mm'
                            type='time'
                            isValid={endTimeIsValid}
                            errorText='End Time must be after the Start Time on the same day'
                            onBlur={updateFieldValue}
                            onChange={updateFieldValue}
                            withBorder={true}
                            data-cy='StudyUsersAddMonitorForm-EndTime'
                        />
                    </InputField>
                </div>
            </div>
            <Checkbox
                notify={notify}
                toggle={toggle}
                className={styles.notify}
                data-cy='StudyUsersAddMonitorForm-CheckBox'
            >
                Notify monitor about {complion4FlagEnabled ? 'binder' : 'study'} access
            </Checkbox>
        </Fragment>
    );
};

const Checkbox = (props) => (
    <div className={styles.checkbox} onClick={props.toggle} value={props.notify}>
        <i
            className={styles.checkboxIcon}
            data-cy='StudyUsersAddMonitorForm-CheckBoxIcon'
        >
            {props.notify ? 'check_box' : 'check_box_outline_blank'}
        </i>
        <p className={styles.notify} data-cy='StudyUsersAddMonitorForm-Children'>
            {props.children}
        </p>
    </div>
);
